module.exports = __webpack_public_path__ + "static/bg-welcome2-87def6d58340212f4d38934c486d98be.jpeg";